var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"school_list"},[_vm._l((_vm.list),function(item){return [_c('school_list_item',{attrs:{"objItem":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }